export default __webpack_public_path__ + "static/media/sin_resultados.1e4b0b49.svg";